import React from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/custom/modal/modal';
import { useAuditorium } from '@/hooks/useAuditorium';
import { PlayfulCardButton } from '@/components/custom/playful-card';

export function AuditoriumViewModalFormName(props) {
  const { createLesson } = useAuditorium();
  const { show, onClose, setLessonName, messages, id, isPlayful } = props;

  const { t } = useTranslation();

  const form = useFormik({
    initialValues: {
      name: ''
    },
    onSubmit: values => {
      setLessonName(values.name);
      createLesson(id, values);
      onClose();
    }
  });

  return (
    <Modal
      show={show}
      onClose={onClose}
    >
      <form
        method="post"
        className="form"
        onSubmit={form.handleSubmit}
      >
        <h2 className="modal__simple-title mb-2 border-b-0">{t('textsCommon.lessonName')}</h2>

        <div className="form__row mt-2">
          <input
            className="form__control"
            id="name"
            name="name"
            type="text"
            placeholder={t('textsCommon.writeHere')}
            value={form.values.name}
            onChange={form.handleChange}
          />
        </div>

        {isPlayful ? (
          <PlayfulCardButton type="submit">{t('auditorium.buttonLessonName')}</PlayfulCardButton>
        ) : (
          <button
            className="btn btn--primary"
            type="submit"
          >
            {t('auditorium.buttonLessonName')}
          </button>
        )}
      </form>
    </Modal>
  );
}
